module.exports = __webpack_public_path__ + "img/damy_account_img.0be0ebdd.jpg";